// Generated file : do not modify
import GraphQuestion from '@/extend/classes/GraphQuestion';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { GraphGridModes } from '@/generated/classes/GraphGrid';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Données d'un projet
export class GraphAnswer {
  // Donnée
  public donnee: string;
  // code
  public code: string;
  // Libellé
  public label: string;
  // Valeur
  public value: string;

  constructor() {
    this.donnee = '';
    this.code = '';
    this.label = '';
    this.value = '';
  }
}

export class GraphMinimum {
  // activite
  public activite: string;
  // Mode
  public mode: GraphGridModes;
  // Minimum
  public montant: number;

  constructor() {
    this.activite = '';
    this.mode = GraphGridModes.NONE;
    this.montant = 0;
  }
}

export default class GraphData  {
  // Graphe
  public graphId: number;
  // section
  public section: string;
  // Première question, ANNEXE si vide
  public firstQuestion: string;
  // Questions et réponses
  public questions: GraphQuestion[];
  // Contexte
  public contexte: string;
  // Type d'objet
  public objType: ObjTypes;
  // Id de l'objet
  public objId: number;
  // Objet sérialisé
  public obj: string;
  // Métier
  public metier: string;
  // Minimum conventionnel
  public minimum: GraphMinimum;
  // Erreur d'exécution
  public error: boolean;

  constructor() {
    this.graphId = 0;
    this.section = '';
    this.firstQuestion = '';
    this.questions = [];
    this.contexte = '';
    this.objType = ObjTypes.NONE;
    this.objId = 0;
    this.obj = '';
    this.metier = '';
    this.minimum = new GraphMinimum();
    this.error = false;
  }

  public static fromJson (obj: GraphData): GraphData {
    const newGraphData: GraphData = new GraphData();
    newGraphData.graphId = obj.graphId;
    newGraphData.section = obj.section;
    newGraphData.firstQuestion = obj.firstQuestion;
    newGraphData.questions = JSON.parse(JSON.stringify(obj.questions));
    newGraphData.contexte = obj.contexte;
    newGraphData.objType = obj.objType;
    newGraphData.objId = obj.objId;
    newGraphData.obj = obj.obj;
    newGraphData.metier = obj.metier;
    newGraphData.minimum = JSON.parse(JSON.stringify(obj.minimum));
    newGraphData.error = obj.error;
    return newGraphData;
  }

  public toJsonGraphData (): string {
    const json = {
      graphId: this.graphId,
      section: this.section,
      firstQuestion: this.firstQuestion,
      questions: this.questions,
      contexte: this.contexte,
      objType: this.objType,
      objId: this.objId,
      obj: this.obj,
      metier: this.metier,
      minimum: this.minimum,
      error: this.error,
    }
    return JSON.stringify(json);
  }

  public fromGraphData (obj: GraphData): void {
    this.graphId = obj.graphId;
    this.section = obj.section;
    this.firstQuestion = obj.firstQuestion;
    this.questions = obj.questions;
    this.contexte = obj.contexte;
    this.objType = obj.objType;
    this.objId = obj.objId;
    this.obj = obj.obj;
    this.metier = obj.metier;
    this.minimum = obj.minimum;
    this.error = obj.error;
  }

  public compareGraphData (value: GraphData): boolean {
    return (this.toJsonGraphData() == value.toJsonGraphData());
  }

  public cloneGraphData (): GraphData {
    return GraphData.fromJson(this);
  }

  public static process (graphData: GraphData): Promise<GraphData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/graphdata/process', graphData, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(GraphData.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static setAdditionalData (graphData: GraphData): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/graphdata/setAdditionalData', graphData, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(graphDatas: GraphData[]) {
  }
}
